import { mapGetters } from 'vuex';

export const masterMixin = {
  data() {
    return {
      status: '',
      checked: true,

      password: '',
      rePassword: '',

      name: '',
      name_en: '',
      gender: 1,
      birthday: '',
      mail_address: '',
      re_mail_address: '',
      phone_number: '',
      address: '',
      hometown: '',
      facebook: '',
      time_zone: '',

      study_status: '',
      school_name: '',
      faculty: '',
      graduation_month: new Date().toISOString().substr(0, 10),
      work_status: '',
      company_name: '',
      industry_type: '',
      occupation_type: [],
      job_type: '',
      work_contract_type: '',
      resignation_month: new Date().toISOString().substr(0, 10),
      jlpt_level: '',
      english_level: '',
      toeic_score: '',
      skill_type: '',
      expect_occupation_type: '',
      work_location: '',

      skillArray: {},

      skills: {},

      dialog: false,
      btnLoading: false
    };
  },

  methods: {
    genderFormat: function (gender) {
      return gender === this.MALE
        ? 'register-page.btn-gender.male'
        : 'register-page.btn-gender.female';
    },

    timezoneFormat: function (time_zone) {
      const arr = this.c_time_zone.filter((ele) => ele.id === time_zone);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    hometownFormat: function (hometown) {
      const arr = this.m.hometown.filter((ele) => ele.id === hometown);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    studyStatusFormat: function (study_status) {
      const arr = this.c_study_status.filter((ele) => ele.id === study_status);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workStatusFormat: function (work_status) {
      const arr = this.c_work_status.filter((ele) => ele.id === work_status);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    industryTypeFormat: function (industry_type) {
      const arr = this.m_industry_type.filter(
        (ele) => ele.id === industry_type
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workContractFormat: function (work_contract_type) {
      const arr = this.c_work_contract_type.filter(
        (ele) => ele.id === work_contract_type
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    japanLevelFormat: function (jlpt_level) {
      const arr = this.c_japanese_level.filter((ele) => ele.id === jlpt_level);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    englishLevelFormat: function (english_level) {
      const arr = this.c_english_level.filter((ele) => ele.id == english_level);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workLocationFormat: function (work_location) {
      const arr = this.m_work_location_applicant.filter(
        (ele) => ele.id === work_location
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },
    areaFormat: function (area) {
      const arr = this.m_area.filter((ele) => ele.id === area);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },
    skillTypeFormat: function () {
      const arr = this.m_skill.filter((ele) => {
        if (this.skill_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    occupationTypeFormat: function (occupation_type) {
      const arr = this.m_occupation_type_no_group.filter((ele) => {
        if (occupation_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    inputExampleFormat: function (input_example) {
      const arr = this.m_input_example.filter(
        (ele) => ele.id === input_example
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    }
  },

  computed: {
    ...mapGetters({
      c_time_zone: 'getCTimeZone',
      c_study_status: 'getCStudyStatus',
      c_work_status: 'getCWorkStatus',
      c_japanese_level: 'getCJapaneseLevel',
      c_english_level: 'getCEnglishLevel',
      c_work_contract_type: 'getCWorkContractType',
      m_skill_type: 'getMSkillType',
      m_skill: 'getMSkill',
      m_area: 'getArea',
      m_work_location_applicant: 'getMWorkLocationApplicant',
      m_occupation_type: 'getMOccupationType',
      m_occupation_type_no_group: 'getMOccupationTypeNoGroup',
      m_input_example: 'getMInputExample',
      m_industry_type: 'getMIndustryType',
      registerStatus: 'getRegisterStatus',
      m_hometown: 'getHometown'
    })
  }
};
